import {
    mintEventEmitter,
    lockEventEmitter,
    type MintEventPayloads,
    type LockEventPayloads,
    dialogEventEmitter,
    type DialogEventPayloads,
    depositEventEmitter,
    type DepositEventPayloads,
    withdrawEventEmitter,
    type WithdrawEventPayloads,
    redeemEventEmitter,
    type RedeemEventPayloads,
    stakeEventEmitter,
    type StakeEventPayloads,
    reallocatePointsEventEmitter,
    type ReallocatePointsEventPayloads,
    cancelExitEventEmitter,
    claimEventEmitter,
    type ClaimEventPayloads,
    type MultiVoteEventPayloads,
    multiVoteEventEmitter,
    type WithdrawUnwoundEventPayloads,
    withdrawUnwoundEventEmitter,
} from "@/events";
import {
    LOCK_ID,
    MINT_ID,
    DIALOG_ID,
    DEPOSIT_ID,
    WITHDRAW_ID,
    REDEEM_ID,
    STAKE_ID,
    REALLOCATE_POINTS_ID,
    CANCEL_EXIT_ID,
    CLAIM_ID,
    MULTIVOTE_ID,
    WITHDRAW_UNWOUND_ID,
} from "@/types";

export const EVENT_EMITTERS = {
    [MINT_ID]: mintEventEmitter,
    [LOCK_ID]: lockEventEmitter,
    [DIALOG_ID]: dialogEventEmitter,
    [DEPOSIT_ID]: depositEventEmitter,
    [WITHDRAW_ID]: withdrawEventEmitter,
    [REDEEM_ID]: redeemEventEmitter,
    [STAKE_ID]: stakeEventEmitter,
    [REALLOCATE_POINTS_ID]: reallocatePointsEventEmitter,
    [CANCEL_EXIT_ID]: cancelExitEventEmitter,
    [CLAIM_ID]: claimEventEmitter,
    [MULTIVOTE_ID]: multiVoteEventEmitter,
    [WITHDRAW_UNWOUND_ID]: withdrawUnwoundEventEmitter,
} as const;

export type eventPayloads = {
    [MINT_ID]: MintEventPayloads;
    [LOCK_ID]: LockEventPayloads;
    [DIALOG_ID]: DialogEventPayloads;
    [DEPOSIT_ID]: DepositEventPayloads;
    [WITHDRAW_ID]: WithdrawEventPayloads;
    [REDEEM_ID]: RedeemEventPayloads;
    [STAKE_ID]: StakeEventPayloads;
    [REALLOCATE_POINTS_ID]: ReallocatePointsEventPayloads;
    [CLAIM_ID]: ClaimEventPayloads;
    [MULTIVOTE_ID]: MultiVoteEventPayloads;
    [WITHDRAW_UNWOUND_ID]: WithdrawUnwoundEventPayloads;
};

export type EventKey = keyof eventPayloads;
export type EventName<T extends EventKey> = keyof eventPayloads[T];
